export default __webpack_public_path__ + "static/media/1932.3347ad18.png";